import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import { FilterTypeLegacy } from '@verantos-dev/types-cohorts';

import {
  addActiveCohortBuilderItemFilter,
  deleteActiveCohortBuilderItemFilter,
} from '../cohortBuilderSlice';
import { selectActiveCohortBuilderItemTemporalConstraints } from '../selectors/cohortBuilderEditModalSelectors';

export const useTemporalConstraints = () => {
  const dispatch = useAppDispatch();
  const temporalConstraints =
    useAppSelector(selectActiveCohortBuilderItemTemporalConstraints) ?? [];

  const onAddTemporalConstraintClick = () => {
    dispatch(addActiveCohortBuilderItemFilter(FilterTypeLegacy.TEMPORAL));
  };

  const onDeleteTemporalConstraintClick = (id: string) => {
    dispatch(
      deleteActiveCohortBuilderItemFilter({
        filterId: id,
        filterType: FilterTypeLegacy.TEMPORAL,
      })
    );
  };

  return {
    temporalConstraints,
    onAddTemporalConstraintClick,
    onDeleteTemporalConstraintClick,
  };
};
